// extracted by mini-css-extract-plugin
export default {"btn":"btn--O8e5N","btnIsDisabled":"btnIsDisabled--8eZiy"};